export interface AscCustomSidebarItemBasicProps {
  id: string;
  name: string;
  date: string;
  children?: any;
  disabled?: boolean;
  pin?: boolean;
  type?: "function";
  onClick?: () => void;
}

export default function AscCustomSidebarItem({
  children,
}: AscCustomSidebarItemBasicProps) {
  return <>{children}</>;
}
